import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
// eslint-disable-next-line import/no-unresolved
import { toast } from 'react-toastify';

import DefaultSpinner from '@components/Loader/Loader';
import { Sentry } from '@config';
import { baseURL, createInternalAPI } from '@config/axiosConfig';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';

export const PayPalButtonWrapper = ({ currency, orderBody, showSpinner }) => {
  const style = { layout: 'vertical' };
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [paypalAccept, setPaypalAccept] = useState(false);
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  const internalAPI = createInternalAPI();
  useEffect(() => {
    dispatch({
      type: 'resetOptions',
      value: {
        ...options,
        currency,
      },
    });
  }, [currency, showSpinner]);

  useEffect(() => {
    if (success) {
      toast.success('Payment completed successfully.', { autoClose: 2500 });
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 2500 });
    }
  }, [success, errorMessage]);

  const createOrder = () =>
    internalAPI
      .post(
        `${baseURL}customer/paypal/transaction/create`,
        JSON.stringify(orderBody)
      )
      .then((res) => res.data)
      .then((data) => data.order_id);

  const onApprove = (data) =>
    internalAPI
      .post(
        `${baseURL}customer/paypal/transaction/capture`,
        JSON.stringify({
          orderID: data.orderID,
        })
      )
      .then((res) => res.data)
      .then((details) => {
        if (details.error) {
          setErrorMessage(details.error);
          return;
        }
        setSuccess(true);
      });

  const onError = (err) => {
    Sentry.captureException(err, {
      tags: { section: 'PayPal' },
    });
    setErrorMessage('An error occurred with your payment ');
  };

  return (
    <>
      {showSpinner && isPending && <DefaultSpinner />}
      <Col md={8} className="offset-2">
        <PayPalButtons
          style={style}
          disabled={!paypalAccept}
          forceReRender={[currency, orderBody, paypalAccept]}
          fundingSource={undefined}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={onError}
        />
      </Col>
      <Col md={10} className="offset-1">
        <hr />
      </Col>
      <Row>
        <Col md={10} className="text-center offset-1">
          The PayPal fee for the transaction is paid by the sender. The fee
          varies by the country and the currency. Approximate{' '}
          <b>handling fee</b> is shown in parentheses. For more details, please
          visit{' '}
          <a href="https://www.paypal.com/webapps/mpp/paypal-fees">
            Paypal fees
          </a>{' '}
          and{' '}
          <a href="https://www.paypal.com/webapps/mpp/ua/useragreement-full#8">
            User Agreement
          </a>
          .
        </Col>
      </Row>
      <Col md={10} className="offset-1">
        <hr />
      </Col>
      <Row>
        <Col md={10} className="offset-1">
          <Form.Check
            name="paypalAccept"
            className="text-center"
            type="checkbox"
            size="sm"
            value={paypalAccept}
            checked={paypalAccept}
            onChange={() => setPaypalAccept(!paypalAccept)}
            label={
              <>
                I have read and agree to the Terms & Conditions.{' '}
                <b>(required)</b>
              </>
            }
          />
        </Col>
      </Row>
    </>
  );
};
